import React from "react";
import { ChevronRight } from "lucide-react";
import { motion } from "framer-motion";
import { events } from "../data/contentData";

function EventsSection({ setReserveOpen }) {
  return (
    <section id="events" className="events section">
      <div className="section-grid events-heading">
        <div className="section-index">02 / 05</div>
        <div>
          <p className="kicker">WHAT'S ON</p>
          <h2>Every night has<br /><i>its own energy.</i></h2>
        </div>
        <p className="lead">Music, guest sets, golden-hour sessions and the kind of weekends that become inside jokes.</p>
      </div>

      <div className="event-list">
        {events.map((event, i) => (
          <motion.button
            className="event-row"
            key={event.number}
            whileHover={{ x: 12 }}
            onClick={() => setReserveOpen(true)}
          >
            <div className="event-date"><span>{event.date}</span><strong>{event.number}</strong></div>
            <div className="event-title"><h3>{event.title}</h3><p>{event.copy}</p></div>
            <ChevronRight size={24} />
          </motion.button>
        ))}
      </div>
    </section>
  );
}

export default EventsSection;
